// extracted by css-extract-rspack-plugin
export default {"icon":"EmailTemplatePicker_icon__iv9k-","checkedIcon":"EmailTemplatePicker_checkedIcon__i4DfD"};